<button type="button" class="btn btn-link close" (click)="hideModalAction.emit()" aria-label="Close">
</button>
<!--action buttons-->
<div *ngIf="params['action'] === 'read'">
    <ul class="list-inline">
        <li class="list-inline-item">
            <button class="btn btn-link" (click)="openFormModalAction.emit();">
                <i class="fas fa-pencil-alt text-primary" aria-hidden="true"></i>
                <span>{{ 'Edit' | translate }}</span>
            </button>
        </li>
        <li class="list-inline-item">
            <button class="btn btn-link" (click)="deleteAction.emit();">
                <i class="far fa-trash-alt text-primary" aria-hidden="true"></i>
                <span>{{ 'Delete' | translate }}</span>
            </button>
        </li>
    </ul>
    <hr/>
</div>